import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import DoubleButton from '../components/DoubleButton';
import InviteContactorForm from './InviteContactorForm';
import useId from 'hooks/useId';
import {connect} from 'react-redux'
import ContractorService from 'services/ContractorService';
import Loading from "../../Loading";

function InviteContactor(
    {
        demandId,
        onClose = () => {
        },
        open = false,
        handleInvite = () => {
        },
        collectPostCode = false,
        collectAddress = false,
        addressRequired = true,
        collectCity = false,
        cityRequired = true,
        collectRegon = false,
        collectCompanySize = false,
        collectIdentity = false,
        checkForExistingVatins = true,
        defaultValues = {},
        title,
        formSubmit,
        contractorList,
        submitButtonLabel = 'add'
    }) {

    const formId = useId();

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        ContractorService.getNipList(demandId).then(() => setLoading(false));
        return () => ContractorService.clearResources(ContractorService.NIP_LIST_RESOURCE_ID)
    }, [demandId])


    const handleClose = () => {
        onClose();
    }

    const handleSubmit = () => {
        formSubmit[formId]()
    }


    return (
        <Dialog
            title={title}
            open={open}
            fullWidth
            onClose={handleClose}
            dialogActions={<DoubleButton
                justify='flex-end'
                labelFirst={Tr('cancel')}
                labelSecond={Tr(submitButtonLabel)}
                onClickFirst={handleClose}
                onClickSecond={handleSubmit}
            />}
        >
            {loading ? <Loading/> :
                <InviteContactorForm
                    onSubmit={handleInvite}
                    id={formId}
                    contractorList={contractorList}
                    defaultValues={defaultValues}
                    collectPostCode={collectPostCode}
                    collectAddress={collectAddress}
                    addressRequired={addressRequired}
                    collectCity={collectCity}
                    cityRequired={cityRequired}
                    collectRegon={collectRegon}
                    collectCompanySize={collectCompanySize}
                    collectIdentity={collectIdentity}
                    checkForExistingVatins={checkForExistingVatins}
                    demandId={demandId}
                />}
        </Dialog>
    )
}

InviteContactor.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func,
    open: PropTypes.bool,
    handleInvite: PropTypes.func,
    collectPostCode: PropTypes.bool,
    collectAddress: PropTypes.bool,
    collectCity: PropTypes.bool,
    collectRegon: PropTypes.bool,
    collectCompanySize: PropTypes.bool,
    collectIdentity: PropTypes.bool,
    checkForExistingVatins: PropTypes.bool,
    defaultValues: PropTypes.object,
    title: PropTypes.string,
    contractorList: PropTypes.object,
    submitButtonLabel: PropTypes.string,
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(InviteContactor);